<now-wbsuche-lib-unterrichtsform-basis-facette
  [id]="'unterrichtsform'"
  [label]="'Unterrichtsform'"
  [modalId]="'unterrichtsformen'"
></now-wbsuche-lib-unterrichtsform-basis-facette>
